import { v4 as uuidv4 } from 'uuid';
import GlobalImportInvoicesView from './GlobalImportInvoicesView';
import GlobalImportInvoicesGridPluginSettings from './GlobalImportInvoicesPluginSettings';


export const GlobalImportInvoicesTab = (): ITab => {
    return {
        id: uuidv4(),
        title: 'Общий импорт накладных',
        view: {
            content: <GlobalImportInvoicesView gridId={uuidv4()} plugin={GlobalImportInvoicesGridPluginSettings} />
        }
    }
}

export default GlobalImportInvoicesTab